<div class="notFound">
    <img src="./../../../assets/images/notfound.png" alt="">
</div>